export function filterQuestions(questions, filterText) {
  if (!filterText) {
    return questions;
  }

  return questions.filter((question) =>
    question.text.toLowerCase().includes(filterText.toLowerCase()),
  );
}
